module.exports = __webpack_public_path__ + "static/media/calendar-circle.615109e6.svg";